"use client"

import Error404Page from "@/views/pages/error/error-404-page"

const Page = () => {
  return <Error404Page />
}

export default Page
